import React, { useState, useCallback } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
const Breadcrumb = ({}) => {
  const location = useLocation();
  const paths = location.pathname.split("/").filter((path) => path);
  console.log("paths::: ", paths);

  const pathNames = {
    ruledatabase: "Roles List",
    pricingdatabase: "Pricing Model List",
    // admin: "Admin Dashboard",
    offersmaping: "Offers Mapping List",
    termsmapping: "Terms Mapping List",
    sandbox: "Run in Sandbox",
    grade: "Grade List",
    pricingmodel: "Procing Model List",
    offeredproduct: "Offered Product List",
    productvalue: "Product Value List",
    termmodel:"Term Model List"
  };

  const lastPath = paths[paths.length - 1];
  const displayName =
    pathNames[lastPath] ||
    (lastPath.match(/^[0-9a-fA-F-]{36}$/)
      ? pathNames[paths[paths.length - 2]]
      : lastPath);

  console.log("tes--", displayName);
  return (
    <>
      <div>
        {location.pathname !== "/ruledatabase" && (
          <ul className="custom_breadcrumb">
            <li>
              <Link to="/ruledatabase">Dashboard</Link>
            </li>

            <li className="current">
              <button>
                {pathNames[paths[paths.length - 1]] || paths[paths.length - 1]}
              </button>
            </li>
          </ul>
        )}
      </div>
    </>
  );
};

export default Breadcrumb;
